export const createMultiples = (value, quantity) => {
  let multiples = [];

  for(let i = 1; i <= quantity; i++) {
    multiples.push(value * i);
  }

  return multiples;
}